module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('DSelect', {
    attrs: {
      "items": _vm.klassCalendars,
      "isLoading": _vm.isLoading,
      "itemsSelected": _vm.selectedKlasses,
      "multiple": false,
      "placeholder": _vm.i18n[_vm.locale]['search']
    },
    on: {
      "add": _vm.add,
      "remove": _vm.remove,
      "update": _vm.setSelectedKasses
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-140f9b06!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DSelect/DSelectKlass.vue
// module id = 1465
// module chunks = 1